import { Anchor, Table } from "@mantine/core";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withTranslation } from "react-i18next";
import Button from "../../../components/Button";
import Page from "../../../components/Page";
import NewDocument from "./NewDocument";
import edit from "../../../assets/edit.svg";
import Delete from "../../../assets/delete.svg";
import { backendUrl } from "../../../constants";

import { showNotification } from "@mantine/notifications";

import "./styles.css";

const Index = ({ documentData, setRefetch }) => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState("");
  const [editData, setEditData] = useState();

  const deleteDocument = async (id) => {
    const data = {
      userId: createdBy.id,
      docId: id,
    };
    console.log("data", data);
    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    };
    await fetch(`${backendUrl}user/deleteJobSeekerDocument`, options)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          showNotification({
            message: "Document Deleted Successfully",
            color: "green",
          });
          // setOpened(false);
          setRefetch((v) => !v);
        } else {
          showNotification({
            message: response.message,
            color: "red",
          });
        }
      })
      .catch((err) => console.error(err));
  };

  const editDocument = (id, data) => {
    setShowModal(true);
    setEditId(id);
    setEditData(data)
  };

  const rows = documentData.map((element) => (
    <tr key={element.id}>
      <td>{element.documentType}</td>
      <td>
        <Anchor href={element.document} target="_blank">
          {element.documentName}
        </Anchor>{" "}
      </td>
      <td className="d-flex gap-2 align-items-center">
        <img
          onClick={() => deleteDocument(element.id)}
          src={Delete}
          width="20px"
          className="delete"
          alt="delete"
        />
        <img
          onClick={() => editDocument(element.id, element.data)}
          src={edit}
          width="20px"
          className="delete"
          alt="edit"
        />
      </td>
    </tr>
  ));

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="location-main">
        <h2 className="text-dark text-center">Documents</h2>
        <Button
          title="Add Document"
          primary={true}
          width="180px"
          style={{ marginLeft: "auto" }}
          onClick={() => setShowModal(true)}
        />
        <Table>
          <thead>
            <tr>
              <th>File Type</th>
              <th>File Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>

        <NewDocument
          opened={showModal}
          setOpened={setShowModal}
          setRefetch={setRefetch}
          editData={editData}
          editId={editId}
        />
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
